import React from 'react';
import { TrendingUp, Search, Zap, DollarSign, Shield } from 'lucide-react';

interface SidebarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const tabs = [
  { id: 'market-movers', label: 'Market Movers', icon: TrendingUp },
  { id: 'deal-finder', label: 'Deal Finder', icon: Search },
  { id: 'arbitrage', label: 'Arbitrage Radar', icon: Zap },
  { id: 'price-checker', label: 'Price Checker', icon: DollarSign },
  { id: 'grading-checker', label: 'Grading Checker', icon: Shield },
];

export default function Sidebar({ activeTab, onTabChange }: SidebarProps) {
  return (
    <aside className="w-64 bg-surface border-r border-border min-h-screen p-4">
      <div className="mb-8">
        <h1 className="text-xl font-bold text-white">OpusSwarm</h1>
        <p className="text-xs text-neutral-500 mt-1">Dashboard Analytics</p>
      </div>
      <nav className="space-y-1">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors
              ${activeTab === tab.id
                ? 'bg-accent/10 text-accent font-medium'
                : 'text-neutral-400 hover:bg-neutral-800 hover:text-neutral-200'
              }`}
          >
            <tab.icon size={18} />
            {tab.label}
          </button>
        ))}
      </nav>
    </aside>
  );
}
